var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaviLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69408 4.83017C7.88996 5.04165 8 5.32843 8 5.62745C8 5.92648 7.88996 6.21326 7.69408 6.42473L2.52205 12.0068L7.69408 17.5889C7.88441 17.8016 7.98973 18.0864 7.98734 18.3821C7.98496 18.6778 7.87508 18.9606 7.68135 19.1697C7.48763 19.3788 7.22557 19.4974 6.95161 19.5C6.67765 19.5025 6.41372 19.3889 6.21666 19.1834L0.305919 12.8041C0.110039 12.5926 0 12.3058 0 12.0068C0 11.7078 0.110039 11.421 0.305919 11.2095L6.21666 4.83017C6.4126 4.61876 6.67831 4.5 6.95537 4.5C7.23243 4.5 7.49814 4.61876 7.69408 4.83017Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviLeftArrow);
export default __webpack_public_path__ + "static/media/navi-left-arrow.9f122c010c729d030ac68581c52942a3.svg";
export { ForwardRef as ReactComponent };